<template>
  <div class="mb-3" v-if="amReady">
    <div class="m-0 p-0 mb-4" v-if="formHeader">
      <h6>{{ this.getFormTitle }}</h6>
    </div>

    <el-dialog :append-to-body="true" :visible.sync="ratesDocumentsDialog" title="" top="2vh" width="100%">
      <ratesDocuments editMode="false" v-if="ratesDocumentsDialog"></ratesDocuments>
    </el-dialog>


    <div class="mb-4" style="font-size: 11pt;">
      <i class="el-icon-info"></i> Document should contains the 3 columns that
      defined below <b class="text-info">Rate</b>, <b class="text-info">Dial Code</b>, and <b class="text-info">Effective Date</b>
    </div>

    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            defaultValue="Rate"
            field_mark="required"
            label="Rate Column"
            name="rate_column"
            placeholder="rate"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            defaultValue="Dial Code"
            field_mark="required"
            label="Dial Code Column"
            name="dialcode_column"
            placeholder="Dial Code"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            defaultValue="Effective Date"
            field_mark="required"
            label="Effective Column"
            name="effective_date_column"
            placeholder="Effective Date"
            rules="required"></dg-text-field>
      </el-col>
    </el-row>

    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :defaultValue="targetVendorId"
            :disabled="(targetVendorId)? true : false"
            :field_span="22"
            :label_span="22"
            :options="vendorsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="vendorChanged"
            field_mark="required"
            label="Vendor"
            name="vendor_id"
            rules="required"></dg-select-field>
      </el-col>

      <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :defaultValue="defaultDivision"
            :disabled="true"
            :field_span="16"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            field_mark="required"
            label="Division"
            name="division_id"
            rules="required"></dg-select-field>
      </el-col>-->

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-file-upload
            :allowed-ext="['xlsx','xls']"
            :control="control"
            :field_span="24"
            :file-size-limit="12"
            :label_span="24"
            field_mark="required"
            label="rates_document"
            name="rate_document"
            rules="required"></dg-file-upload>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-radio-field
            :control="control"
            :defaultValue="'add_new_only'"
            :field_span="22"
            :label_span="22"
            :options="uploadOptions"
            field_mark="required"
            label="upload_options"
            name="upload_options"
            rules="required"></dg-radio-field>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                          v-show="!this.validData"></dg-label-field>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">

          <dg-button :click="showRatesDocument" :translate="false" class="mr-2" fieldSize="mini" icon="el-icon-document" text="Rates Documents" type="primary"></dg-button>

          <dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>

        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  components: {
    ratesDocuments: () => import('./../rates-documents/page/View.vue'),
  },
  mixins: [fieldController],
  props: {
    afterUploadCallback: {
      required: false
    },
    targetVendorId: {
      required: false,
      default: null
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      ratesDocumentsDialog: false,
      control: this,
      amReady: true,
      defaultDivision: null,
      uploadOptions: [
        {
          label: 'add_new_only',
          value: 'add_new_only',
          link_label: ''
        },
        {
          label: 'clean_previous_rates',
          value: 'clean_previous_rates',
          link_label: ''
        }
      ],
      requestOn: false,
      editable: !this.editMode,
      vendorsList: [],
      divisionsList: [],
      module: {
        ...module
      }
    }
  },
  beforeMount() {
    this.getVendorDropDownList({divisionId: false}).then(r => {
      this.vendorsList = r
    })

    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
    })
  },
  computed: {
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'Upload';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-upload2';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  methods: {
    showRatesDocument() {
      this.ratesDocumentsDialog = true
    },
    vendorChanged(params) {
      let vendorId = params.field.field_value
      this.getVendorDivision({id: vendorId}).then((r) => {
        this.fields['division_id'].field.field_value = r.data
        this.fields['division_id'].field.validateMessage = ''
        this.fields['division_id'].field.updateValue()
      })
    },
    ...$mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList',
      getVendorDivision: 'getVendorDivision',
    }),
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false;
      }
      return true;
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;

        this.dataModel['rate_column'] = this.dataModel['rate_column'].trim().replace(/(\r\n|\n|\r)/gm, "")
        this.dataModel['dialcode_column'] = this.dataModel['dialcode_column'].trim().replace(/(\r\n|\n|\r)/gm, "")
        this.dataModel['effective_date_column'] = this.dataModel['effective_date_column'].trim().replace(/(\r\n|\n|\r)/gm, "")

        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'importRates';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          $vue.nextTick(() => {
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          this.amReady = false

          let responseData = error.response.data.message
          if(this.IsJsonString(responseData)) {
            let data = JSON.parse(responseData)
            let status = data.status


            if (status == 200) {
              if (this.afterUploadCallback) {
                this.afterUploadCallback()
              }
              notify({
                type: 'success',
                title: 'Uploaded',
              });
            } else {
              notify({
                type: 'error',
                title: 'Error uploading',
              });
            }
          } else {
            notify({
              type: 'error',
              title: 'Error uploading',
            });
          }


          $vue.nextTick(() => {
            this.amReady = true
          })

        }).finally(() => {
          context.requestOn = false
          context.amReady = true
        })

      })
    }
  }
}
</script>
